<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="back()"></button>

            <button pButton pRipple type="button" icon="pi pi-save" label="" [pTooltip]="translations.lbl_update"
                class="p-button-raised p-button-success p-m-2 z-5" (click)="saveUpdateDelete('UPDATE')"></button>

            <button pButton pRipple type="button" icon="pi pi-trash" label=""
                [pTooltip]="translations.lbl_delete_record" class="p-button-raised p-button-danger p-m-2 z-5"
                (click)="saveUpdateDelete('DELETE')"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT COORDINATION ID -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_coordination}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCoordination')?.value}}</span>
                    </div>

                    <!-- INPUT LANGUAGE
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_language}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedLanguage')?.value?.value}}</span>
                    </div> -->

                    <!-- INPUT PERIOD -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_period}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedPeriod')?.value?.descrip}}</span>
                    </div>

                    <!-- INPUT CURRENCIES -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_period}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedCurrency')?.value?.value}}</span>
                    </div>

                    <!-- INPUT COORDINACIÓN ID -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_document_id}}</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedDocId').value}}</span>
                    </div>

                    <!-- INPUT GUIDE -->
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{translations.lbl_guide}}:</span>
                        <span class="p-text-bold">{{globalUserDataForm.get('selectedGuide')?.value?.fullName}}</span>
                    </div>

                    <!-- INPUT DATE -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Fecha </span>
                        </div>
                        <div class="p-col-12 p-md-8">

                            <p-calendar formControlName="selectedDate" [touchUI]="true" [readonlyInput]="true"
                                inputId="touchui" [showIcon]="true" dateFormat="dd-mm-yy"
                                [minDate]="globalUserDataForm.get('data_minDate1').value"
                                [maxDate]="globalUserDataForm.get('data_maxDate1').value"
                                [defaultDate]="defaultViewDate" placeholder="{{translations.lbl_select}} {{translations.lbl_date}}"></p-calendar>
                        </div>
                    </div>

                    <!-- INPUT DETAIL -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Concepto</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedDetail"
                                placeholder="Ingrese un concepto">
                        </div>
                    </div>

                    <!-- INPUT ACCOUNT -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Cheque</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedAmount"
                                placeholder="Ingrese un numero">
                        </div>
                    </div>

                    <!-- INPUT AMOUNT -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Ingresos</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-inputNumber placeholder="{{translations.entry}} {{translations.amount}}"
                                formControlName="selectedIncomes" mode="decimal" [showButtons]="true"
                                inputId="minmax-buttons" [minFractionDigits]="2" [maxFractionDigits]="2"
                                [locale]="'es-MX'"></p-inputNumber>
                        </div>
                    </div>

                    <!-- INPUT STORE -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="stores && stores.length > 2">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Sera transferido a:</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [virtualScroll]="true" [itemSize]="3" id="lstStores" [options]="stores"
                                formControlName="selectedStoreTo" placeholder="Seleccione una tienda"
                                optionLabel="descri" [showClear]="true" [filter]="false"></p-dropdown>
                        </div>
                    </div>

                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView>

        <!-- TAB PANEL FII -->
        <p-tabPanel [header]="'FII Die'">
            <p-table emptyMessage="Registros no existentes" #dt1 [columns]="colsFII" [value]="dataFII"
                [paginator]="true" [rows]="40" [showCurrentPageReport]="false" [globalFilterFields]="colsGlFII"
                responsive="true" editMode="row" responsive="true" dataKey="concepId">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel"
                                (click)="exportExcel(dataFII,colsFiFII,'FII-RECEIVE-PAYABLE')"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf"
                                (click)="exportPdf(dataFII,colsFiFII,'FII-RECEIVE-PAYABLE')"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetListFII()"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th class="text-left">{{translations.lbl_id}}</th>
                        <th class="text-left">{{translations.lbl_description}}</th>
                        <th class="amount">{{translations.lbl_current_balance}}
                            ({{globalUserDataForm.get('selectedCurrency')?.value?.valueId}})</th>
                        <th class="amount">{{translations.lbl_amount}}
                            ({{globalUserDataForm.get('selectedCurrency')?.value?.valueId}})</th>
                        <th class="amount">{{translations.lbl_actions}}</th>

                    </tr>
                </ng-template>

                <!-- BODY -->



                <ng-template pTemplate="body" let-rowData let-columns="columns" let-ri="rowIndex">

                    <ng-template #conceptDIEOutput>
                        {{ rowData.fiiDtl.amount }}
                    </ng-template>

                    <tr [pEditableRow]="rowData">
                        <td class="text-left">
                            {{ rowData.concepId}}
                        </td>
                        <td class="text-left">
                            {{ rowData.conceptDescr}}
                        </td>

                        <!-- Saldo Actual -->
                        <td class="amount">
                            {{ rowData.balance | number: '1.2-2'}}
                        </td>

                        <td class="amount">
                            <div *ngIf="rowData.editing; else conceptDIEOutput">
                                <input pInputText [ngClass]="getDIEConceptsClass()" type="number"
                                    [(ngModel)]="rowData.fiiDtl.amount">
                            </div>
                        </td>


                        <td class="amount">

                            <button *ngIf="!rowData.editing && rowData.fiiDtl.editable" pButton pRipple type="button"
                                icon="pi pi-pencil" label="{{lbl_save}}"
                                class="p-button-rounded p-button-warning p-mr-2"
                                (click)="onRowEditInitDIE(rowData)"></button>

                            <button *ngIf="rowData.editing" pButton pRipple type="button" icon="pi pi-check"
                                (click)="onRowEditSaveDIE(rowData)"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>

                            <button *ngIf="rowData.editing" pButton pRipple type="button" icon="pi pi-times"
                                (click)="onRowEditCancelDIE(rowData)"
                                class="p-button-rounded p-button-text p-button-danger p-mr-2"></button>

                        </td>

                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>

                        <td [attr.colspan]="columns ? columns.length : 9">
                            No se encontraron registros en la consulta solicitada.
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataFII != null ? dataFII.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

        <!-- OFRENDAS -->
        <p-tabPanel [header]="'OFRENDAS'" *ngIf="dataParent.conType == 'I'">

            <p-table emptyMessage="Registros no existentes" [columns]="colsFi" [value]="dataOffers" [paginator]="true"
                [rows]="40" [showCurrentPageReport]="false" responsive="true" editMode="row" selectionMode="multiple"
                dataKey="docRefer">

                <!-- HEADER -->
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th pTooltip="{{ col.header }}">
                                {{ col.header }}
                            </th>
                        </ng-container>
                        <th class="coordName-nowrap text-right">{{translations.lbl_edit}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-data let-ri="rowIndex">

                    <ng-template pTemplate="output" #amountOutput>
                        <span>
                            {{ data.amount}}
                        </span>
                    </ng-template>

                    <ng-template pTemplate="output" #unitsOutput>
                        <span>
                            {{ data.units }}
                        </span>
                    </ng-template>

                    <tr [pSelectableRow]="data" [pEditableRow]="data">
                        <td> {{ data.docRefer }} </td>
                        <td> {{ data.serviceName }} </td>
                        <td> {{ data.weekDay }} </td>
                        <td> {{ data.schedule }} </td>
                        <td> {{ data.participants }} </td>
                        <td>
                            <div *ngIf="data.editing; else amountOutput">
                                <input pInputText [ngClass]="getOfferClass()" type="number" [(ngModel)]="data.amount">
                            </div>
                        </td>

                        <td>
                            <div *ngIf="data.editing; else unitsOutput">
                                <input pInputText type="number" [(ngModel)]="data.units">
                            </div>
                        </td>

                        <td style="text-align:center">
                            <button *ngIf="!data.editing" pButton pRipple type="button" icon="pi pi-pencil"
                                (click)="onRowEditInit(data)" class="p-button-rounded p-button-text">
                            </button>
                            <button *ngIf="data.editing" pButton pRipple type="button" icon="pi pi-check"
                                (click)="onRowEditSave(data, ri)"
                                class="p-button-rounded p-button-text p-button-success p-mr-2"></button>
                            <button *ngIf="data.editing" pButton pRipple type="button" icon="pi pi-times"
                                (click)="onRowEditCancel(data, ri)"
                                class="p-button-rounded p-button-text p-button-danger"></button>
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{dataOffers != null ? dataOffers.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>
        </p-tabPanel>

    </p-tabView>
</div>

<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>